<template>
    <div class="fixed fixed-max-sm grid xs-grid-cols-1">
        <h2 class="f3 text-bold">Related articles</h2>
        <mvtLazyload ref="lazyload" :async="true" data-role="articlecard">
            <div class="grid xs-grid-cols-1 sm-grid-cols-2 lg-grid-cols-3">
                <ArticlePresentational v-for="article in relatedArticles" :href="article.link ||(glb.appUrl + article.url)" :key="article.title"
                    :image="article.image ? article.image : (glb.cdnUrl + 'vimages/nophoto_small.svg')"
                    :headerText="article.title"
                    :descriptionText="article.description"
                    :footerText="`By ${ article.author }, ${$filters.formatDate(article.date)}`"
                    :imageAltText="article.imageAltText"
                />
            </div>
        </mvtLazyload>
    </div>
</template>

<script src="./mvt-articlegrid.js"></script>

